// composables/useApiFetchBase.ts
import type { UseFetchOptions } from '#app'

export function getApiFetchConfig <T>(options: UseFetchOptions<T, unknown> = {}, api: 'api1' | 'api2' = 'api1') {
  const config = useRuntimeConfig();

  let baseURL = config.public.useProxy === 'true'
    ? config.public.proxyTargetApi
    : config.public.apiBaseURL;

  const token = api === 'api1'
    ? config.public.apiTokenId
    : config.public.apiTokenId;

  const authToken = useCookie<string | null>('iqa-token')
  const { $i18n } = useNuxtApp();
  const userData = JSON.parse(localStorage.getItem("iqa-auth") || "{}");
  const selectedTenant = JSON.parse(localStorage.getItem("iqa-auth") || '""').selectedTenant;
  const tenant = selectedTenant?.code ?? null;
  const headers = {
    ...(authToken.value && ({'Authorization' : `Bearer ${authToken.value}`})),
    'Content-Type': 'application/json',
    ...(tenant && ({'X-Tenant' : `${tenant}`})),
    ...(tenant && ({'tenantCode' : `${tenant}`})),
    'Accept-Language': $i18n?.locale.value || 'en',
    ...(options.headers || {}),
  }

  return { baseURL, headers };
}

let isLoadingOpen = false;
let loadingTimeout: ReturnType<typeof setTimeout> | null = null;

export function handlePending(pending: Ref<boolean>) {
  // Initial check
  if (pending.value && !isLoadingOpen) {
    // Set a 1-second delay before showing
    loadingTimeout = setTimeout(() => {
      swal_loading();
      isLoadingOpen = true;
    }, 1000);
  }

  // Watcher
  watch(pending, (isPending) => {
    if (isPending) {
      if (!isLoadingOpen && !loadingTimeout) {
        // Set 1-second delay before showing
        loadingTimeout = setTimeout(() => {
          swal_loading();
          isLoadingOpen = true;
        }, 1000);
      }
    } else {
      // Clear timeout if pending resolved before 1 second
      if (loadingTimeout) {
        clearTimeout(loadingTimeout);
        loadingTimeout = null;
      }

      if (isLoadingOpen) {
        swal_close();
        isLoadingOpen = false;
      }
    }
  });
}


export async function handleFatalError(message: string)
{  
  await swal_oops(message);
}

export function handleError<T>(error: any, url: string): { success: false; message: string; data: T } {
  
  const { $i18n } = useNuxtApp()
    
  const responseData = error?.data as any;
  const mensajes = responseData?.errors
    ? Object.entries(responseData.errors)
        .map(([key, val]) => `${key}: ${(val as string[]).join(', ')}`)
        .join('\n')
    : responseData?.message || $i18n.t('common.message.form_validation.unexpected_error');

  return {
    success: false,
    message: `${mensajes}`,
    data: responseData?.data || {} as T, // This will be overridden per fetcher
  };
}


export async function redirectToLoginIfNeeded() {
  const router = useRouter();
  const route = useRoute();
  if (import.meta.client && route.path !== '/login')
  {
    if(route.path == '/customers' || route.path == '/portal' || route.path == '/portal/certificates' )
    {  
      await router.push('/customers');
      return;
    }
    await router.push('/login');
  }
}